import { Icon } from '../ui/icons';

/**
 * Sidebar navigation for the Procurement & Inventory module.
 * Grouped into sections the way enterprise P2P suites organise the workflow:
 * sourcing → purchasing → inventory → finance.
 */
export const NAV_SECTIONS = [
  {
    label: null,
    items: [{ to: '/', label: 'Dashboard', Icon: Icon.LayoutDashboard, end: true, perm: 'dashboard.view' }],
  },
  {
    label: 'Sourcing',
    items: [
      { to: '/suppliers', label: 'Suppliers', Icon: Icon.Building, perm: 'suppliers.view' },
      { to: '/catalog', label: 'Catalog', Icon: Icon.Package, perm: 'catalog.view' },
      { to: '/menu-engineering', label: 'Menu Engineering', Icon: Icon.ConciergeBell, perm: 'recipes.view', match: ['/menu-engineering', '/recipes'] },
    ],
  },
  {
    label: 'Purchasing',
    items: [
      { to: '/requisitions', label: 'Requisitions', Icon: Icon.ListChecks, perm: 'requisitions.view' },
      { to: '/market-list', label: 'Market List', Icon: Icon.ClipboardList, perm: 'marketlist.view' },
      { to: '/purchase-orders', label: 'Purchase Orders', Icon: Icon.ShoppingCart, perm: 'purchaseorders.view' },
      { to: '/receiving', label: 'Receiving', Icon: Icon.ArrowDownCircle, perm: 'receiving.view' },
      { to: '/returns', label: 'Returns', Icon: Icon.ArrowUpCircle, perm: 'returns.view' },
    ],
  },
  {
    label: 'Inventory',
    items: [
      { to: '/inventory', label: 'Stock on Hand', Icon: Icon.Boxes, perm: 'inventory.view' },
      { to: '/counts', label: 'Stock Counts', Icon: Icon.ClipboardList, perm: 'inventory.view' },
      { to: '/transfers', label: 'Transfers', Icon: Icon.ArrowLeftRight, perm: 'inventory.view' },
      { to: '/adjustments', label: 'Adjustments', Icon: Icon.Trash, perm: 'inventory.view' },
      { to: '/usage-variance', label: 'Usage & Variance', Icon: Icon.TrendingDown, perm: 'usage.view' },
    ],
  },
  {
    label: 'Finance',
    items: [
      { to: '/budgets', label: 'Budgets', Icon: Icon.Wallet, perm: 'budgets.view' },
      { to: '/invoices', label: 'Invoices', Icon: Icon.FileText, perm: 'invoices.view' },
      { to: '/reports', label: 'Reports', Icon: Icon.BarChart, perm: 'reports.view' },
    ],
  },
  {
    label: 'Administration',
    items: [
      { to: '/users', label: 'Users & roles', Icon: Icon.Users, perm: 'users.view' },
      { to: '/settings', label: 'Settings', Icon: Icon.Settings, perm: 'settings.manage' },
    ],
  },
];

export const ALL_NAV_ITEMS = NAV_SECTIONS.flatMap((s) => s.items);
